import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "explanation"
};
const _hoisted_2 = {
  class: "permanent"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "swiper swiper-container",
  ref: "swiperWarp"
};
const _hoisted_5 = {
  class: "swiper-wrapper"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "eTitle"
};
const _hoisted_9 = {
  key: 0,
  class: "location"
};
const _hoisted_10 = {
  class: "temporary"
};
const _hoisted_11 = {
  class: "title"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "detail"
};
const _hoisted_15 = {
  class: "name"
};
const _hoisted_16 = {
  key: 0,
  class: "time"
};
const _hoisted_17 = {
  class: "location"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_guideBottom = _resolveComponent("guideBottom");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(!$data.language ? '常设展览' : 'Permanent exhibition'), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.exhibitions.filter(item => {
    return item.exhibType == '常设展览';
  }), item => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-image swiper-slide",
      onClick: $event => $options.showExhitonList(item)
    }, [_createElementVNode("img", {
      src: item.images
    }, null, 8, _hoisted_7), _createElementVNode("div", _hoisted_8, _toDisplayString(!$data.language ? item.exhibName : item.en_name), 1), item.exhibitionLocation || item.en_location ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($data.language ? 'location' : '地点') + "：" + _toDisplayString(!$data.language ? item.exhibitionLocation : item.en_location), 1)) : _createCommentVNode("", true)], 8, _hoisted_6);
  }), 256))]), _cache[0] || (_cache[0] = _createElementVNode("div", {
    class: "swiper-pagination"
  }, null, -1))], 512)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(!$data.language ? '临时展览' : 'Temporary Exhibition'), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.exhibitions.filter(item => {
    return item.exhibType == '临时展览';
  }), item => {
    return _openBlock(), _createElementBlock("div", {
      class: "exhibitions",
      onClick: $event => $options.showExhitonList(item)
    }, [_createElementVNode("img", {
      src: item.images
    }, null, 8, _hoisted_13), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(!$data.language ? item.exhibName : item.en_name), 1), item.exhibBegin ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(item.exhibBegin.replaceAll('-', '/')) + "一" + _toDisplayString(item.exhibEnd ? item.exhibEnd.replaceAll('-', '/') : ''), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_17, _toDisplayString(!$data.language ? item.exhibitionLocation : item.en_location), 1)])], 8, _hoisted_12);
  }), 256))]), _ctx.$route.query.fid == 152288 ? (_openBlock(), _createBlock(_component_guideBottom, {
    key: 0
  })) : _createCommentVNode("", true)]);
}